import {PDF_COMPLETED_TYPE_COLOR_MAP_BY_COLOR_NAME, PDF_ICON_MAP_BY_TYPE, PDF_OPEN_TYPE_COLOR_MAP_BY_COLOR_NAME} from "./constants";
import {WorkflowStatusType} from "../../../workflowStatus/constants";


export function getPdfColorByColorIdAndStatusType(colorId, type) {
    if (type === WorkflowStatusType.OPEN) {
        return PDF_OPEN_TYPE_COLOR_MAP_BY_COLOR_NAME[colorId]
    } else if (type === WorkflowStatusType.COMPLETED) {
        return PDF_COMPLETED_TYPE_COLOR_MAP_BY_COLOR_NAME[colorId]
    }
}

export function getPdfIconNameByType(workflowStatusType) {
    return PDF_ICON_MAP_BY_TYPE[workflowStatusType]
}


// WEBPACK FOOTER //
// ./web/js/user/viewtt/pdf/utils.js